// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__zU5Xm","label":"SetPasswdForm_label__pvaVN"};